import React, { useContext } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { AuthContext } from "../contexts/AuthContext";
import AuthProvider from "../contexts/AuthContext"
import PrivateRoute from './PrivateRoute'
import '../scss/style.scss'
import Login from '../components/Users/Login'
import Dashboard from '../components/Dashboard'
import Bebidas from '../components/Bebidas'
import Restaurantes from '../components/Restaurantes'
import Admins from '../components/Users/Admins'
import Usuarios from '../components/Users/Usuarios'
import ForgotPassword from '../components/ForgotPassword'
import EntregaBeneficios from '../components/EntregaBeneficios';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// ✅ Componente separado que SÍ está dentro del Provider, y es para poder definir segun el role que ruta estara disponible
function AppRoutes() {
  let { user1 } = useContext(AuthContext); // Ahora funciona correctamente

  return (
    <React.Suspense fallback={loading}>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/forgot" component={ForgotPassword} />
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/bebidas" component={Bebidas} />
        {user1?.role === 'restaurant' && (
          <>
            <PrivateRoute exact path="/entregaBeneficios" component={EntregaBeneficios} />
          </>
        )}

        <PrivateRoute exact path="/restaurantes" component={Restaurantes} />
        <PrivateRoute exact path="/admins" component={Admins} />
        <PrivateRoute exact path="/usuarios" component={Usuarios} />
      </Switch>
    </React.Suspense>
  )
}

// ✅ Este componente solo provee el contexto
function Routes() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes /> {/* AppRoutes ya vive dentro del Provider */}
      </BrowserRouter>
    </AuthProvider>
  )
}

export default Routes